import { Box, Divider, withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsHeaderLarge from 'ui-elements/typography/FsHeaderLarge';
import FsBody from 'ui-elements/typography/FsBody';

export const FsHelloWrapperBox = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(1),
  },
}))(Box);

export const FsCounterBox = withStyles(({ palette, spacing }) => ({
  root: {
    background: palette.grey[200],
    padding: spacing(0.5, 1),
    borderRadius: spacing(0.5),
    marginLeft: spacing(2),
    fontSize: 12,
    '& > i': {
      fontWeight: 700,
    },
  },
}))(Box);

export const FsHello = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[300],
  },
}))(FsCaption);

export const FsCenterBoxTitle = withStyles(() => ({
  root: {
    fontSize: 38,
    fontWeight: 700,
    lineHeight: 1.3,
  },
}))(FsHeaderLarge);

export const FsCenterBoxSubTitle = withStyles(({ palette, spacing }) => ({
  root: {
    color: palette.grey[400],
    padding: spacing(1.5, 0, 2),
    fontSize: 18,
  },
}))(FsBody);

export const FsLastStepCaption = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(2, 0, 1),
    fontSize: 20,
  },
}))(FsBody);

export const FsCenterBoxLine = withStyles(({ palette }) => ({
  root: {
    backgroundColor: palette.primary.main,
    width: 32,
    height: 4,
    borderRadius: 2,
  },
}))(Divider);

export const FsStep = withStyles(() => ({
  root: {},
}))(Box);
